import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotMovies from './components/HotMovies';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '90影院',
    url: 'https://www.90cinema.com/',
    description: '90影院提供8090影院高清、超清、4K、蓝光画质影视资源，电影电视剧综艺动漫免费在线观看，播放流畅不缓冲，全集持续更新。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.90cinema.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.90cinema.com/',
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <HotMovies />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}